import { Box } from '@material-ui/core';

import { LoadingIndicator } from './loading-indicator';

/**
 * Show app loading screen until app is ready.
 *
 * @returns {JSX.Element}
 */
export function AppLoadingScreen(): JSX.Element {
  return (
    <Box display="flex" alignItems="center" justifyContent="center">
      <LoadingIndicator />
    </Box>
  );
}
